


export enum ShowReasonColumn {
	planning = 'planning',
	execution = 'execution',
	planningAndExecution = 'planningAndExecution',
}


export function isShowReasonColumn(value: unknown): value is ShowReasonColumn {
	return typeof value === 'string' && Object.values(ShowReasonColumn).includes(value as ShowReasonColumn);
}